import styled from 'styled-components';
interface GradienteProps {
  color: string;
  small?:boolean;
}
interface LegendeProps {
  top?: number;
  left?:number
}

export const Container = styled.div`
  width: 180px;
  height:   160px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid var(--light-gray);
  z-index: 1000;
  overflow: hidden;
  padding: 12px 12px 0 12px;
  grid-area: map;
  margin-left: 8%;
  .leaflet-container{
  background-color: transparent;
  }
  @media (max-width: 820px) {
    box-shadow:none;
    border: none;
    margin-top: 6%;
  }
`
export const Header = styled.div`

display:flex;
/* justify-content: space-between; */
max-height: 40px;
min-height: 40px;
display:flex ;
justify-content: flex-end;
img{
  width: 34px;
  height: 34px;
}
p{
  letter-spacing: 0px;
  color: #161615;
  opacity: 1;
  font-weight: 600;
  font-size: 12px !important;
  margin-left: 10px;
}
@media (max-width: 820px) {
  display: none;
}
`
export const BoxMap = styled.div`
display: flex;
justify-content: center;
width: 100%;
height: 100%;
`

export const Gradiente = styled.div<GradienteProps>`
background: rgb(29,71,150);
/* background: linear-gradient(90deg, ${props => props?.color} 0%, rgba(255,255,255,1) 100%); */
background: linear-gradient(90deg,  rgba(255,255,255,1)  0%,${props => props?.color} 100%);
width: ${props => props.small ? '64': '93'}px;
height: ${props => props.small ? '9': '13'}px;;
`

export const Legend = styled.div<LegendeProps>`
position:  relative;
top: ${props => props?.top ? props?.top +'px': 'none' };
left: ${props => props?.left ? props?.left +'px': 'none' };

small{
  font-size: 11px !important;
  letter-spacing: 0px;
  color: #161615;
  font-weight: 700;
}

.indices{
  display: flex;
  justify-content: space-between;
  width: ${props => props?.left ? '93': '64' }px;
}
`

export const NumberSmall = styled.p`
font-size: 10px !important;
letter-spacing: 0px;
color: #161615;

`


export const Close = styled.div`
position:  absolute;
width:15px ;
height:15px ;
right: 25px;
top: 15px;
cursor:pointer;
background-color: black ;
clip-path: polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%);
`

export const Overlay = styled.div`
  width: 180px;
  height:   161px;
  z-index: 9999 ;
  position: absolute;
  right: 14px;
  top: 0;
  .lupa{
    display: none;
  }
  h4{
    display: none;
  }
  &:hover{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color:rgba(252, 252, 252, 0.9);
    cursor: pointer;
    .lupa{
      display: flex;
    }
    h4{
    opacity: 1;
    display: block;
    width: auto!important;
    }
  }

@media (max-width: 820px) {
  display: none;
}
`

export const Lupa = styled.div`
width: 30px ;
height: 30px ;
background-color:#EAEAEA;
border: 2px solid #CDC8C8;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;

/* &:hover{
  opacity: 0.8;
} */
`

export const BoxLegendMap = styled.div`
width: 100%;
height: 30px;
top: -90px;
position: relative ;
display: flex;
justify-content: space-between;
align-items: center;

`